import { PopupButton } from "@typeform/embed-react";
import { t } from "@/i18n-js/instance";
import { isProductionEnv } from "@/react/helpers/envHelpers";
import "@typeform/embed/build/css/popup.css";

const TYPEFORM_POPUP_SIZE = 66; // Percentage of screen size for popup

interface CancellationTypeformButtonProps {
  cancellingMetadata: Record<string, string> | undefined;
}

export const CancellationTypeformButton = ({
  cancellingMetadata,
}: CancellationTypeformButtonProps) => {
  const typeFormId = isProductionEnv() ? "UJB6AB55" : "nH21fEOM";

  return (
    <>
      {/* Typeform has 2 flows: one to cancel the subscription and another */}
      {/* to reach out and redirect to the community, so we cannot use TypeForm */}
      {/* callbacks like onSubmit or onEndingButtonClick to redirect to Stripe Portal */}
      {/* in case of canceling the subscription as we don't know which is the flow. */}
      {/* Redirection will be handled on the ending button from Typeform for each flow */}
      <PopupButton
        id={typeFormId}
        size={TYPEFORM_POPUP_SIZE}
        medium="demo-test"
        className="underline"
        hidden={cancellingMetadata}
      >
        {t(
          "settings.billing.manage_billing.cancellation.description.end_subscription",
        )}
      </PopupButton>
    </>
  );
};
